module.exports = __webpack_public_path__ + "static/media/check_24px.19a10276.svg";